import { Box, Container, Heading, Stack, Text } from '@chakra-ui/react'
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons'

import * as url from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import Icon from '@/components/UI/Icon/Icon'

export default function TutorResourcePageLayout({
  title,
  backHref = url.getUrl('tutor'),
  eyebrow,
  titleBadge,
  description,
  headerAction,
  tabs,
  maxWidth,
  children,
}: {
  title: string
  backHref?: string
  eyebrow?: React.ReactNode | null
  titleBadge?: React.ReactNode | null
  description?: React.ReactNode | null
  headerAction?: React.ReactNode | null
  tabs?: React.ReactNode | null
  maxWidth?: string | null
  children: React.ReactNode
}): JSX.Element {
  return (
    <Container maxWidth={maxWidth ?? undefined}>
      <Stack direction="column" spacing="32px">
        <Stack direction="column" spacing="16px">
          <Stack direction="column" spacing="8px">
            <ShwLink href={backHref} variant="basic" alignSelf="flex-start">
              <Stack direction="row" align="center" spacing="6px">
                <Icon size="xs" faIcon={faChevronLeft} color="primary.fg" omitContainer />
                <Text color="primary.fg" fontWeight={600}>
                  Back
                </Text>
              </Stack>
            </ShwLink>
            {eyebrow != null ? <Text variant="eyebrow">{eyebrow}</Text> : null}
            <Stack direction="row" align="center" spacing="12px">
              <Heading as="h1" size="2xl">
                {title}
              </Heading>
              {titleBadge}
            </Stack>
            {description != null ? <Box color="fg.muted">{description}</Box> : null}
          </Stack>
          {headerAction}
        </Stack>
        {tabs != null ? tabs : <Box borderBottom="2px solid" borderColor="border.muted" />}
        <Box>{children}</Box>
      </Stack>
    </Container>
  )
}
